module.exports = __webpack_public_path__ + "static/media/external-link-square-alt.9f62e363.svg";